<template>
  <div class="doc-content">
    <div
      v-html="content"
      class="markdown-body html-content"
      ref="content"
      style="scrollbar-width: none; -ms-overflow-style: none; overflow-y: auto"
    ></div>
    <div
      class="nav"
      v-if="treeData.length > 1 || treeData[0]?.children?.length > 0"
    >
      <el-tree
        class="tree"
        ref="tree"
        node-key="uuid"
        :data="treeData"
        :props="defaultProps"
        default-expand-all
        :show-icon="false"
        :expand-on-click-node="false"
      >
        <div class="custom-tree-node" slot-scope="{ data }">
          <div class="tree-text" @click="toDiv(data.uuid)">{{ data.text }}</div>
          <!-- <a class="anchor" :href="`#${data.uuid}`">
					{{ data.text }}
				</a> -->
        </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
import "github-markdown-css";
import hljs from "highlight.js";
import "highlight.js/styles/atom-one-light.css"; //引入一种语法的高亮
import { marked } from "marked";
import { Tree } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

export default {
  name: "MarkdownView",
  components: {
    "el-tree": Tree,
  },
  props: {
    textData: {
      type: String,
      default: "",
      required: true,
    },
  },
  data() {
    return {
      treeData: [],
      defaultProps: {
        label: "text",
        children: "children",
      },
    };
  },
  created() {
    this.$nextTick(() => {
      this.getCatalog();
      hljs.highlightAll();
    });
  },
  computed: {
    content() {
      return marked(this.textData);
    },
  },
  watch: {
    textData() {
      this.$nextTick(() => {
        this.getCatalog();
        // 重置滚动位置到顶部
        if (this.$refs.content) {
          this.$refs.content.scrollTop = 0;
        }
      });
    },
  },
  methods: {
    // 根据内容获取目录
    getCatalog() {
      const h = ["h1", "h2", "h3", "h4", "h5", "h6"];
      const elements = this.$refs.content.querySelectorAll(
        "h1, h2, h3, h4, h5, h6"
      );
      let hElements = [];
      for (const key of elements) {
        if (h.indexOf(key.localName) > -1) {
          let text;
          if (key.children && key.children.length) {
            text = this.getText(key.children);
          } else {
            text = key.innerHTML;
          }
          console.log("key:", key);

          // 为 DOM 元素添加 id
          const newId = key.id || `heading-${hElements.length}`;
          key.id = newId; // 将 id 设置到实际 DOM 元素中

          hElements.push({
            hLevel: parseInt(key.localName[1]),
            text,
            id: newId, // 这里存储的 id 是从 DOM 获取的
            uuid: newId, // 使用生成的 id
          });
          console.log("hElements:", hElements);
        }
      }
      let result = this.toTree(hElements);
      this.treeData = result;
      console.log("treeData:", this.treeData);
    },
    toTree(flatArr) {
      var tree = [];
      var copyArr = flatArr.map(function (item) {
        return item;
      });

      // 根据指定级别查找该级别的子孙级，并删除掉已经查找到的子孙级
      var getChildrenByLevel = function (currentLevelItem, arr) {
        if (!currentLevelItem) {
          return [];
        }
        // 将level值转成负数，再进行比较
        var minusCurrentLevel = -currentLevelItem.hLevel;
        var children = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          var levelItem = arr[i];
          if (-levelItem.hLevel < minusCurrentLevel) {
            children.push(levelItem);
          } else {
            // 只找最近那些子孙级
            break;
          }
        }
        // 从数组中删除已经找到的那些子孙级，以免影响到其他子孙级的查找
        if (children.length > 0) {
          arr.splice(0, children.length);
        }
        return children;
      };

      var getTree = function (result, arr, level) {
        // 首先将数组第一位移除掉，并添加到结果集中
        var currentItem = arr.shift();
        if (!currentItem) return;

        currentItem.level = level;
        result.push(currentItem);
        while (arr.length > 0) {
          if (!currentItem) {
            return;
          }
          // 根据当前级别获取它的子孙级
          var children = getChildrenByLevel(currentItem, arr);
          // 如果当前级别没有子孙级则开始下一个
          if (children.length == 0) {
            currentItem = arr.shift();
            if (!currentItem) continue;
            currentItem.level = level;
            result.push(currentItem);
            continue;
          }
          currentItem.children = [];
          // 查找到的子孙级继续查找子孙级
          getTree(currentItem.children, children, level + 1);
        }
      };
      getTree(tree, copyArr, 1);
      return tree;
    },
    getText(children) {
      let result = null;
      if (!children.length) return result;
      for (let i = 0; i < children.length; i++) {
        if (children[i].children && children[i].children.length) {
          result = this.getText(children[i].children);
        } else {
          result = children[i].innerHTML;
        }
      }
      return result;
    },
    toDiv(uuid) {
      console.log("treeData:", this.treeData);
      const element = document.getElementById(uuid);
      console.log("uuid:", uuid);
      console.log("element:", element);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .el-tree-node__expand-icon {
  display: none;
}

::v-deep .el-tree-node__content {
  height: 36px;
}

.doc-content {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  height: calc(100vh - 80px);
  /* width: calc(100vw - 360px); */
  width: 100%;
}

.nav {
  /* width: 25%;
  max-width: 380px; */
  padding-right: 20px;
  overflow-y: auto;
}

.tree {
  font-family: "HarmonyOS Sans SC-Medium", sans-serif;
  /* width: calc(270px - 104px); */
  /* height: 100%; */
  margin-left: 24px;
  padding: 8px 8px 8px 22px;
  overflow-y: auto;
  flex-shrink: 0;
  border-left: 1px solid #e5e7eb;
  font-weight: 500;
  font-size: 14px;
  color: #1f2937;
  line-height: 20px;
  text-align: left;
}

.html-content {
  font-family: "HarmonyOS Sans SC-Medium", sans-serif;
  width: 100%;
  overflow-y: auto;
  flex: 1;
  padding: 48px 24px 48px 32px;
  text-align: left;
}

::v-deep .html-content h1 {
  font-size: 36px;
  line-height: 54px;
  color: #000;
  border: none;
  margin-top: 32px;
}

::v-deep .html-content h2 {
  font-size: 30px;
  line-height: 45px;
  color: #000;
  border: none;
  margin-top: 32px;
  margin-bottom: 6.4px;
}

::v-deep .html-content h3 {
  font-size: 24px;
  line-height: 36px;
  color: #000;
  border: none;
  margin-top: 28px;
}

::v-deep .html-content h4 {
  font-size: 20px;
  line-height: 30px;
  color: #000;
  border: none;
  margin-top: 28px;
}

::v-deep .html-content h5 {
  font-size: 18px;
  line-height: 27px;
  color: #000;
  border: none;
  margin-top: 28px;
}

::v-deep .html-content h6 {
  font-size: 16px;
  line-height: 24px;
  color: #000;
  border: none;
  margin-top: 28px;
}

::v-deep .html-content {
  color: #334155;
}

::v-deep .html-content th {
  color: #1f2937;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 4px 0;
  cursor: pointer;
}

.custom-tree-node:hover {
  color: #2d81fe;
}

.html-content::-webkit-scrollbar {
  display: none;
}

.tree-text {
  width: 100%;
  padding-left: 12px;
}
</style>

